export default __webpack_public_path__ + "static/media/makers-place.eb72f941.png";